// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"621":"fd56a492b3099735","2293":"475a5537892b39d1"}[chunkId] + ".css";
};